import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
	{path: 'login', loadChildren: () => import('./View/Login/LoginViewModule').then(m => m.LoginViewModule)},
	// ビデオ通話（医師・スタッフ用）。呼び出し画面から別タブで開かれる
	{path: 'video', loadChildren: () => import('./View/VideoCall/VideoCallModule').then((m) => m.VideoCallModule)},
	{path: '', loadChildren: () => import('./View/Main/AppViewModule').then((m) => m.AppViewModule)},
	{
		path: 'error',
		loadChildren: () => import('./View/Error/ApplicationErrorModule').then((m) => m.ApplicationErrorModule)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
